module.exports = __webpack_public_path__ + "static/img/banner_2.5983f44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/banner_2.jpg
// module id = tYSo
// module chunks = 0